/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Search_Members_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search name or email" |
*
* @param {Team_Manager_Search_Members_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_search_members_placeholder = /** @type {((inputs?: Team_Manager_Search_Members_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Search_Members_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher un nom ou un e-mail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name oder E-Mail suchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca nome o email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск по имени или почте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar nombre o correo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索姓名或电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前またはメールで検索")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम या ईमेल खोजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pesquisar nome ou email")
	return /** @type {LocalizedString} */ ("Search name or email")
});